import React, { ForwardRefRenderFunction, forwardRef, CSSProperties, MouseEventHandler, AnimationEventHandler, TransitionEventHandler, TouchEventHandler } from 'react';
import classNames from 'classnames';
import TextareaAutoSize from 'react-autosize-textarea';
import { TextareaProps } from '@tarojs/components/types/Textarea';

interface ITextareaProps
  extends Omit<
    TextareaProps,
    'style' | 'onClick' | 'onAnimationStart' | 'onAnimationEnd' | 'onAnimationIteration' | 'onTransitionEnd' | 'onTouchStart' | 'onTouchMove' | 'onTouchEnd' | 'onTouchCancel'
  > {
  readOnly?: boolean;
  style?: CSSProperties;
  onClick?: MouseEventHandler<HTMLTextAreaElement>;
  onAnimationStart?: AnimationEventHandler<HTMLTextAreaElement>;
  onAnimationEnd?: AnimationEventHandler<HTMLTextAreaElement>;
  onAnimationIteration?: AnimationEventHandler<HTMLTextAreaElement>;
  onTransitionEnd?: TransitionEventHandler<HTMLTextAreaElement>;
  onTouchStart?: TouchEventHandler<HTMLTextAreaElement>;
  onTouchMove?: TouchEventHandler<HTMLTextAreaElement>;
  onTouchEnd?: TouchEventHandler<HTMLTextAreaElement>;
  onTouchCancel?: TouchEventHandler<HTMLTextAreaElement>;
}

const Textarea: ForwardRefRenderFunction<any, ITextareaProps> = (
  { onConfirm, autoHeight, className, disabled, maxlength, onInput: propsOnInput, onFocus: propsOnFocus, onBlur: propsOnBlur, ...restProps },
  ref,
) => {
  const rootCls = classNames('ink-textarea__textarea', 'ink-textarea__textarea--h5', { 'ink-textarea__textarea--disabled': disabled }, className);

  const onKeyPress = (e: any) => {
    if (e.key === 'Enter' && typeof onConfirm === 'function') {
      onConfirm(e);
    }
  };

  const onInput = (e: any) => {
    if (propsOnInput) {
      propsOnInput({ detail: { value: e.target.value } } as any);
    }
  };

  const onFocus = (e: any) => {
    if (propsOnFocus) {
      propsOnFocus({ detail: { value: e.target.value } } as any);
    }
  };

  const onBlur = (e: any) => {
    if (propsOnBlur) {
      propsOnBlur({ detail: { value: e.target.value } } as any);
    }
  };

  if (autoHeight) {
    return <TextareaAutoSize {...restProps} onChange={onInput} onFocus={onFocus} onBlur={onBlur} maxLength={maxlength} ref={ref} className={rootCls} disabled={disabled} onKeyPress={onKeyPress} />;
  }

  return <textarea {...restProps} onChange={onInput} onFocus={onFocus} onBlur={onBlur} maxLength={maxlength} className={rootCls} ref={ref} onKeyPress={onKeyPress} />;
};
export default forwardRef(Textarea);
